module.exports = __webpack_public_path__ + "static/szkoleniowa-2-5a6068eb0e1a5aec8f342e8bf07b9ba6.jpg";